import { StyleRules } from '@material-ui/core';

export default (): StyleRules => ({
  nauIcon: {
    marginRight: '10px',
  },
});
